import React from "react";
import { Page, Text, Image, View } from "@react-pdf/renderer";
import { DateTime } from "luxon";
import tools from "../../../../helpers/tools";

const PVDocV2 = ({ styles, ep, inscriptions, orgas, title, constants }) => {
  const nbSuspensions = inscriptions.filter(
    (i) => i.type === "SUSPENSION",
  ).length;
  const nbSuppressions = inscriptions.filter(
    (i) => i.type === "SUPPRESSION",
  ).length;
  const nbTotal = inscriptions.length;

  const nbAccord = inscriptions.filter(
    (i) => i.directorDecision === "ACCORD",
  ).length;
  const nbSurseoir = inscriptions.filter(
    (i) => i.directorDecision === "A_SURSEOIR",
  ).length;

  const nbSuspAccord = inscriptions.filter(
    (i) => i.type === "SUSPENSION" && i.directorDecision === "ACCORD",
  ).length;
  const nbSuspSurseoir = inscriptions.filter(
    (i) => i.type === "SUSPENSION" && i.directorDecision === "A_SURSEOIR",
  ).length;

  const nbSuppAccord = inscriptions.filter(
    (i) => i.type === "SUPPRESSION" && i.directorDecision === "ACCORD",
  ).length;
  const nbSuppSurseoir = inscriptions.filter(
    (i) => i.type === "SUPPRESSION" && i.directorDecision === "A_SURSEOIR",
  ).length;

  const getOrganizations = (jur) => {
    let orgaSlugs = (jur.userManager.organizations || []).map((orgId) => {
      return orgas.find((or) => or.id === orgId) || {};
    });
    const cafOrga = orgaSlugs.find((org) => org.slugName === "CAF");
    if (cafOrga) {
      orgaSlugs = orgaSlugs.filter((org) => org.slugName === "CAF");
    }
    return orgaSlugs
      .filter((org) => org.name)
      .map((org) => org.name)
      .join(", ");
  };

  const getRole = (jur) => {
    if (jur.userManager.id === ep.president) return "Président(e)";
    return "Membre";
  };

  const getMandate = (jur) => {
    const mandates = constants?.INVITATION_MANDATES || [];
    const mandate = mandates.find((inv) => inv.id === jur.userMandate);
    return mandate ? mandate.name : "";
  };

  return (
    <Page wrap size="A4" orientation="portrait">
      {/* Header */}
      <View style={{ display: "flex", flexDirection: "row", padding: 20 }}>
        <View style={{ width: "10%" }}>
          <Image
            style={{ height: 80, width: 55 }}
            src="/assets/logo-espoar.png"
          />
        </View>
        <View style={{ width: "87%", paddingLeft: "2%" }}>
          <View style={{ ...styles.title, textAlign: "left" }}>{title}</View>
        </View>
      </View>

      {/* Quorum */}
      <View style={{ textAlign: "center", paddingLeft: 20, paddingRight: 20 }}>
        <Text style={{ ...styles.title }}>QUORUM</Text>
        <Text style={{ ...styles.info }}>
          Le quorum est atteint et la commission peut valablement délibérer.
        </Text>
      </View>

      {/* Jury table */}
      <View style={{ paddingLeft: 20, paddingRight: 20 }}>
        <View style={{ ...styles.tableRow }}>
          <Text style={{ ...styles.tableCell4, ...styles.tableHead }}>
            MEMBRE
          </Text>
          <Text style={{ ...styles.tableCell4, ...styles.tableHead }}>
            ORGANISME
          </Text>
          <Text style={{ ...styles.tableCell4, ...styles.tableHead }}>
            FONCTION
          </Text>
          <Text style={{ ...styles.tableCell4, ...styles.tableHead }}>
            ÉMARGEMENT
          </Text>
        </View>
        {(ep.jury || [])
          .filter((jur) => jur.isPresent)
          .map((jur, k) => (
            <View style={{ ...styles.tableRow }} key={`jur${k}`}>
              <Text style={{ ...styles.tableCell4 }}>
                {tools.getFullname(jur.userManager)}
              </Text>
              <Text style={{ ...styles.tableCell4 }}>
                {getOrganizations(jur)}
              </Text>
              <Text style={{ ...styles.tableCell4 }}>
                {getRole(jur)} {getMandate(jur)}
              </Text>
              <Text style={{ ...styles.tableCell4, color: "green" }}>
                Présent
              </Text>
            </View>
          ))}
      </View>

      {/* Summary section */}
      <View style={{ textAlign: "center", paddingLeft: 20, paddingRight: 20 }}>
        <Text style={{ ...styles.title }}>
          AVIS DE L'ÉQUIPE PLURIDISCIPLINAIRE
        </Text>
        <Text style={{ ...styles.info }}>
          La liste des dossiers présentés et les avis de la commission est en
          annexe du présent procès-verbal.
        </Text>
      </View>

      {/* Summary table */}
      <View style={{ paddingLeft: 20, paddingRight: 20 }}>
        <View style={{ ...styles.tableRow }}>
          <Text style={{ ...styles.tableCell3, ...styles.tableHead }}>
            OBJET
          </Text>
          <Text style={{ ...styles.tableCell3, ...styles.tableHead }}>
            AVIS EP
          </Text>
          <Text style={{ ...styles.tableCell3, ...styles.tableHead }}>
            DÉCISIONS DIRECTEUR
          </Text>
        </View>
      </View>
      <View style={{ ...styles.tableRow, paddingLeft: 20, paddingRight: 20 }}>
        <Text style={{ ...styles.tableCell3 }}>Suspensions</Text>
        <Text style={{ ...styles.tableCell3 }}>{nbSuspensions}</Text>
        <Text style={{ ...styles.tableCell3, textAlign: "center" }}>
          {nbSuspAccord} accord / {nbSuspSurseoir} à surseoir
        </Text>
      </View>
      <View style={{ ...styles.tableRow, paddingLeft: 20, paddingRight: 20 }}>
        <Text style={{ ...styles.tableCell3 }}>Suppressions</Text>
        <Text style={{ ...styles.tableCell3 }}>{nbSuppressions}</Text>
        <Text style={{ ...styles.tableCell3, textAlign: "center" }}>
          {nbSuppAccord} accord / {nbSuppSurseoir} à surseoir
        </Text>
      </View>
      <View style={{ ...styles.tableRow, paddingLeft: 20, paddingRight: 20 }}>
        <Text style={{ ...styles.tableCell3 }}>Total</Text>
        <Text style={{ ...styles.tableCell3 }}>{nbTotal}</Text>
        <Text style={{ ...styles.tableCell3, textAlign: "center" }}>
          {nbAccord} accord / {nbSurseoir} à surseoir
        </Text>
      </View>

      {/* Signatures */}
      <View style={{ paddingLeft: 20, paddingRight: 20, marginTop: 10 }}>
        <View style={{ ...styles.tableRow, height: 80 }}>
          <View style={{ ...styles.tableCell3, ...styles.textCenter }}>
            <Text>Fait à{"     "}</Text>
            <Text>
              le {DateTime.local().setLocale("fr").toFormat("dd LLLL yyyy")}
            </Text>
          </View>
          <View style={{ ...styles.tableCell3, ...styles.textCenter }}>
            <Text>Le(la) Président(e) de l'Équipe Pluridisciplinaire</Text>
            {ep.closedBy && (
              <Text style={{ fontSize: 9, marginTop: 4 }}>
                Clôturé par {tools.getFullname(ep.closedBy)}{" "}
                {ep.closedAt &&
                  DateTime.fromISO(ep.closedAt).toFormat(
                    "dd/MM/yyyy 'à' HH'h'mm",
                  )}
              </Text>
            )}
          </View>
          <View style={{ ...styles.tableCell3, ...styles.textCenter }}>
            <Text>Le directeur</Text>
            {ep.endedBy && (
              <Text style={{ fontSize: 9, marginTop: 4 }}>
                Finalisé par {tools.getFullname(ep.endedBy)}{" "}
                {ep.endedAt &&
                  DateTime.fromISO(ep.endedAt).toFormat(
                    "dd/MM/yyyy 'à' HH'h'mm",
                  )}
              </Text>
            )}
          </View>
        </View>
      </View>
    </Page>
  );
};

export default PVDocV2;
